import { mapChallengeErrorCodeToResource } from '../constants/resources';
import { PhoneVerificationAction, PhoneVerificationActionType } from './action';
import { PhoneVerificationState } from './state';

const phoneVerificationStateReducer = (
  oldState: PhoneVerificationState,
  action: PhoneVerificationAction
): PhoneVerificationState => {
  const newState = { ...oldState };
  switch (action.type) {
    case PhoneVerificationActionType.SET_CHALLENGE_COMPLETED:
      newState.onChallengeCompletedData = action.onChallengeCompletedData;
      return newState;
    case PhoneVerificationActionType.SET_CHALLENGE_INVALIDATED:
      newState.onChallengeInvalidatedData = {
        errorCode: action.errorCode,
        errorMessage: mapChallengeErrorCodeToResource(oldState.resources, action.errorCode)
      };
      return newState;
    default:
      return oldState;
  }
};

export default phoneVerificationStateReducer;
